import VideoJsAdapter from "@javascripts/adapters/videojs_adapter"
import Component from '@javascripts/components/component'
import anime from 'animejs/lib/anime.es.js';
import { evt } from '@javascripts/advertisements/constant'

export default class AdsTransition extends Component {
  constructor(player, options) {
    super(player, options)
  }

  createEl() {
    const el = VideoJsAdapter.global().createEl('div', {
      id: 'ads-transition-container',
      className: 'vjs-hidden'
    })

    return el
  }

  fadeIn() {
    this._volume = this.player().volume()

    this.player().trigger(evt.FADE_OUT_AUDIO)
    
    this.decreaseAudio()

    return anime({
      targets: this.el(),
      opacity: 1,
      duration: 2000,
      easing: 'easeInOutQuad',
    }).finished
  }

  fadeOut() {
    this.player().trigger(evt.FADE_IN_AUDIO)

    this.increaseAudio()

    anime({
      targets: this.el(),
      opacity: 0,
      duration: 2000,
      easing: 'easeInOutQuad',
      complete: () => this.hide()
    })
  }

  decreaseAudio() {
    const target = { vol: this.player().volume() }

    anime({
      targets: target,
      vol: 0,
      easing: 'linear',
      duration: 2000,
      update: () => {
        this.player().volume(target.vol);
      }
    })
  }

  increaseAudio() {
    const target = { vol: this.player().volume() }

    anime({
      targets: target,
      vol: this._volume || 1,
      easing: 'linear',
      duration: 2000,
      update: () => {
        this.player().volume(target.vol);
      }
    })
  }
}

VideoJsAdapter.registerComponent('AdsTransition', AdsTransition)
